// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.primary-headline-h1 {
  font-style: normal;
  font-weight: bold;
  font-size: 72px;
  line-height: 115%;
}

.headline-h2 {
  font-style: normal;
  font-weight: 600;
  font-size: 48px;
  line-height: 110%;
}

.headline-h3 {
  font-style: normal;
  font-weight: 600;
  font-size: 36px;
  line-height: 120%;
}

.subtitile-h4 {
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 140%;
}

.subtitile-h5 {
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 140%;
}

.body-font-p {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 150%;
}

.airbook-logo {
  width: 38px;
  height: 39.25px;
}

.subtitle-space {
  margin-top: 32px;
}

.body-space {
  margin-top: 24px;
}

.action-space {
  padding-top: 48px;
}

@media screen and (max-width: 451px) {
  .headline-h1 {
    font-size: 48px;
    line-height: 120%;
    letter-spacing: -0.01em;
  }
  .headline-h2 {
    font-size: 40px;
    line-height: 110%;
    letter-spacing: -0.02em;
  }
  .headline-h3 {
    font-size: 24px;
    line-height: 140%;
  }
  .subtitile-h4 {
    font-size: 20px;
    line-height: 140%;
  }
  .subtitile-h5 {
    font-size: 18px;
    line-height: 140%;
  }
  .airbook-logo {
    width: 19.36px;
    height: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/guide.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;AADF;;AAKA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAFF;;AAMA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAHF;;AAOA;EACE,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;AAJF;;AAQA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AALF;;AASA;EACE,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AANF;;AAUA;EACE,WAAA;EACA,eAAA;AAPF;;AAUA;EACE,gBAAA;AAPF;;AAUA;EACE,gBAAA;AAPF;;AAUA;EACE,iBAAA;AAPF;;AAUA;EACE;IACE,eAAA;IACA,iBAAA;IACA,uBAAA;EAPF;EAUA;IACE,eAAA;IACA,iBAAA;IACA,uBAAA;EARF;EAWA;IACE,eAAA;IACA,iBAAA;EATF;EAYA;IACE,eAAA;IACA,iBAAA;EAVF;EAaA;IACE,eAAA;IACA,iBAAA;EAXF;EAcA;IACE,cAAA;IACA,YAAA;EAZF;AACF","sourcesContent":["@import \"variables\";\n\n.primary-headline-h1 {\n  font-style: normal;\n  font-weight: bold;\n  font-size: 72px;\n  line-height: 115%;\n  // font-family: $font-bold;\n}\n\n.headline-h2 {\n  font-style: normal;\n  font-weight: 600;\n  font-size: 48px;\n  line-height: 110%;\n  // font-family: $font-bold;\n}\n\n.headline-h3 {\n  font-style: normal;\n  font-weight: 600;\n  font-size: 36px;\n  line-height: 120%;\n  // font-family: $font-medium;\n}\n\n.subtitile-h4 {\n  font-style: normal;\n  font-weight: bold;\n  font-size: 24px;\n  line-height: 140%;\n  // font-family: $font-medium;\n}\n\n.subtitile-h5 {\n  font-style: normal;\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 140%;\n  // font-family: $font-medium;\n}\n\n.body-font-p {\n  font-style: normal;\n  font-weight: normal;\n  font-size: 16px;\n  line-height: 150%;\n  // font-family: $font-regular;\n}\n\n.airbook-logo {\n  width: 38px;\n  height: 39.25px;\n}\n\n.subtitle-space {\n  margin-top: 32px;\n}\n\n.body-space {\n  margin-top: 24px;\n}\n\n.action-space {\n  padding-top: 48px;\n}\n\n@media screen and ($mobile-media) {\n  .headline-h1 {\n    font-size: 48px;\n    line-height: 120%;\n    letter-spacing: -0.01em;\n  }\n\n  .headline-h2 {\n    font-size: 40px;\n    line-height: 110%;\n    letter-spacing: -0.02em;\n  }\n\n  .headline-h3 {\n    font-size: 24px;\n    line-height: 140%;\n  }\n\n  .subtitile-h4 {\n    font-size: 20px;\n    line-height: 140%;\n  }\n\n  .subtitile-h5 {\n    font-size: 18px;\n    line-height: 140%;\n  }\n\n  .airbook-logo {\n    width: 19.36px;\n    height: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
